import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { customerservice } from "../../../config";
import Form from "./forms";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import { useNavigate } from "react-router-dom";

const base_url = customerservice.uri;

const CustomerChargesPage = () => {
  const navigate = useNavigate();
  const customerId = localStorage.getItem("CustomerId");
  const customerName = localStorage.getItem("CustomerName");

  const columns = [
    { field: "Id", headerName: "ID", flex: 0.5 },
    { field: "ChargeName", headerName: "Charge Name", flex: 1.5 },
    {
      field: "ChargeAmount",
      headerName: "Charge Amount",
      flex: 1,
      renderCell: (params) => {
        const val = params.value != null ? Number(params.value) : 0;
        return (
          <Typography>
            {val.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Typography>
        );
      }
    },
    { field: "ChargeType", headerName: "Charge Type", flex: 1 },
    { field: "Description", headerName: "Description", flex: 2 },
  ];

  const actions = {
    entity: "Customer Charge",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
      modelName: "ids",
      inputObjectName: "activateDeactivateCustomerCharges",
    },
    dataObject: {
      ignoreFields: ["CreatedDate", "CreatedBy", "UpdatedDate", "UpdatedBy", "CustomerId", "CompanyId"],
      objectName: "customerChargesByCustomerId",
      parameters: { customerId: parseInt(customerId) },
      inputObjectName: "charge",
    },
    showMore: {
      search: false,
      min: 0,
      max: 0,
    },
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => navigate(-1)} variant="contained" color="primary">
          Back to Customers
        </Button>
      </Box>
      <DynamicTableForJson
        title={`Customer Charges for ${customerName || "Customer"}`}
        subtitle={`Manage additional charges and fees applied to Customer ID: ${customerId}`}
        columns={columns}
        FormComponent={Form}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default CustomerChargesPage;
